<template>
  <v-row style="opacity: 0.4; border-top:1px solid gray;" >
    <v-col lg="3" v-if="!isMobile" align-self="center">
      <domain-image height="70" transparent></domain-image>
    </v-col>
    <v-col lg="4" align-self="center" >
      <v-list-item v-if="userDetails.Office.BrandName">
        <v-list-item-content>
            {{ userDetails.Office.BrandName }}
          <v-list-item-subtitle>
            Επωνυμία
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        dense
        v-if="userDetails.Office.PhoneNumber"
        :href="'tel:' + userDetails.Office.PhoneNumber"
      >
        <v-list-item-action>
          <v-icon>mdi-phone</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ userDetails.Office.PhoneNumber }}
          </v-list-item-title>
          <v-list-item-subtitle> τηλέφωνο </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item dense v-if="userDetails.Office.Address">
        <v-list-item-action>
          <v-icon>mdi-map</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ userDetails.Office.Address }}, {{ userDetails.Office.AreaName }},
            TK:{{ userDetails.Office.PostCode }}
          </v-list-item-title>
          <v-list-item-subtitle> Διεύθυνση </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col lg="4" align-self="center">
      <v-list-item dense v-for="i in userDetails.Office.Ibans" :key="i">
        <v-list-item-action>
          <v-icon>mdi-bank</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ i }}
          </v-list-item-title>
          <v-list-item-subtitle> IBAN </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
  </v-row>
</template>

<script>
import { Office } from "@/wl-core/api/classes/Office";
import { mapGetters } from "vuex";
import DomainImage from "@/components/DomainImage";

export default {
  name: "OfficeInfoFooter",
  components: { DomainImage },
  computed: {
    ...mapGetters(["userDetails","isMobile"]),
  },
  props: {
    hideToolbar: { type: Boolean, default: null, required: false },
  },
};
</script>

<style scoped>
</style>